<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import * as _ from "lodash";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import Flash from "@shared/services/flashv2.js";
  import CartStore from "@retailer/svelte/stores/CartStore";

  import { DISCOUNT_AMOUNT_TYPES } from "@shared/types/Deals";
  import type { DealProgress, DealTier } from "@shared/types/Deals";
  import type { CartType } from "@shared/types/Cart";

  export let nextDealTier: DealTier;
  export let dealTier: DealTier;

  let dealSatisfied: boolean = true;
  let dealProgress: any = {};
  let loading = true;
  let updating = true;
  let cart: CartType;

  const url =
    `/api/retailer/deals/${dealTier.deal_id}/show_deal_progress?` +
    new URLSearchParams({
      deal_tier_id: dealTier.deal_tier_id.toString(),
    });

  let satisfiedHeader, satisfiedMessage;
  if (dealTier.amount_type === DISCOUNT_AMOUNT_TYPES.RIP) {
    satisfiedHeader = "RIP Qualified!";
    satisfiedMessage = `${dealTier.distributor_name} will determine the final RIP you will receive on your invoice`;
  } else {
    satisfiedHeader = "Deal Qualified!";
    satisfiedMessage =
      "You've qualified for this deal! The best deal you've met for each product will be applied in the cart.";
  }

  const getProgressDealStatus = async () => {
    updating = true;
    return await fetch(url, {
      headers: {
        "X-Tiz-Retailer-Context": window["$rootScope"].currentRetailerId,
      },
    })
      .then(res => res.json())
      .then(data => {
        if (!dealSatisfied && data.progress >= 100) {
          Flash.now({
            type: "success",
            message: satisfiedMessage,
            header: satisfiedHeader,
          });
        }

        dealProgress = data as DealProgress;
        dealSatisfied = data.progress >= 100;
        updating = loading = false;
      });
  };

  $: cart = $CartStore;
  $: {
    cart;
    getProgressDealStatus();
  }
</script>

{#if loading}
  <span class="loading">Loading</span>
{:else}
  <strong style="min-width: 160px;">
    {#if dealSatisfied}
      <div class="fizz-text-deal fizz-text-align-right fizz-flex-row-4 fizz-align-content-start">
        <Icon width="16" height="16" type="DealSatisfied" className="fizz-icon-16 fizz-text-deal" />
        <span class={updating ? "loading" : ""}>
          {dealProgress.quantity}/{dealProgress.total}
          {pluralize(_.capitalize(dealTier.deal_tier_label), dealProgress.total)}
          &ndash;
          {#if dealTier.amount_type === DISCOUNT_AMOUNT_TYPES.RIP}
            RIP qualified!
          {:else}
            Deal applied!
          {/if}
        </span>
      </div>
      {#if nextDealTier}
        <div class="fizz-text-subdued">
          {nextDealTier.tier_available_label}
        </div>
      {/if}
    {:else}
      <div class="align-center">
        <span class={updating ? "loading" : ""}>
          {dealProgress.quantity}/{dealProgress.total}
          {pluralize(_.capitalize(dealTier.deal_tier_label), dealProgress.total)}
        </span>
        <div class="fizz-progress-tracker" style="--progress: {dealProgress.progress}%;" />
      </div>
    {/if}
  </strong>
{/if}
